export default [
    {
        route: 'dashboard.index',
        label: 'messages.sitemap.dashboard.dashboard',
        showInSidebar: true
    }
]
